module.exports = __webpack_public_path__ + "static/media/DSC_0148-2.40fb3ed0.jpg";